import React, { Component } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { VendorsFilter, VendorsTable } from "../components";
import * as vendor from "../redux";

export class VendorList extends Component {
    componentDidMount() {
        this.props.getVendors();
    }

    render() {
        const { vendors, pagination, changePage, loading, extraProps } = this.props;
        const base_op = {
            className: "vendor_list",
            title: "Vendor Management",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Vendor Management" }],
            extraProps,
            loading
        };
        const vendorTable_op = {
            list: vendors,
            pagination: {
                ...pagination,
                changePage
            }
        };
        return (
            <Base {...base_op}>
                <VendorsFilter onSubmit={this.onFilter} />
                <VendorsTable {...vendorTable_op} />
            </Base>
        );
    }

    onFilter = filters => {
        this.props.changeFilters(filters);
    };
}

const mapStateToProps = store => ({
    vendors: store.vendor.list,
    loading: store.vendor.loading,
    loaded: store.vendor.loaded,
    pagination: store.vendor.pagination
});

const mapDispatchToProps = dispatch => ({
    getVendors: () => dispatch(vendor.actions.getVendors()),
    changePage: page => dispatch(vendor.actions.changePage(page)),
    changeFilters: filters => dispatch(vendor.actions.updateFilter(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(VendorList);
